module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about01-c751d65726c01307d48d2c5bbcbbfc20.png";